// Node
import { times } from 'underscore';


export default class CampListLoading extends React.Component {
  constructor(props) {
    super(props);
    this.card_loading = this.card_loading.bind(this);
    // Влияет на скорость заполнения страницы контентом
    // Число получено экспериментальным путем
    this.campCardsCount = props.camps_count ?? 20;
  }

  shouldComponentUpdate() {
    return false;
  }

  card_loading(index) {
    return (
      <div className='card card_big card-preload'
           key={index}
      >
        <div className='card-preload__thumbs'>
          <div className='card-preload__thumb preload__thumb card-loader card-loader--tabs'/>
          <div className='card-preload__thumb preload__thumb card-loader card-loader--tabs'/>
          <div className='card-preload__thumb preload__thumb card-loader card-loader--tabs'/>
        </div>
        <div className='preload__name card-loader card-loader--tabs'/>
        <div className='preload__line preload__line_w90pr card-loader card-loader--tabs'/>
        <div className='preload__line preload__line_w88px preload__line_h19px card-loader card-loader--tabs'/>
        <div className='preload__line preload__line_w90pr card-loader card-loader--tabs'/>
        <div className='preload__line preload__line_w90pr card-loader card-loader--tabs'/>
      </div>
    );
  }

  sanatoriums_card_loading(index) {
    return (
        <div className='card card_big card-preload'
             key={index}
        >
          <div className='card-preload__sanatoriums__thumbs'>
            <div className='card-preload__sanatoriums__thumb preload__thumb card-loader card-loader--tabs'/>
          </div>
          <div className='preload__name card-loader card-loader--tabs'/>
          <div className='preload__line preload__line_w90pr card-loader card-loader--tabs'/>
          <div className='preload__line preload__line_w90pr preload__line_h19px card-loader card-loader--tabs'/>
          <div className='preload__line preload__line_w90pr card-loader card-loader--tabs'/>
          <div className='preload__line preload__line_w90pr card-loader card-loader--tabs'/>
        </div>
    );
  }


  render() {
    return (
      <div className='cards'>
        {window.website_type === '0' ? times(this.campCardsCount, this.card_loading) : times(this.campCardsCount, this.sanatoriums_card_loading)}
      </div>
    );
  }
}
